import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoDirective } from '@jsverse/transloco';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { MenuActionsComponent } from '@modules/shared/menu-actions/menu-actions.component';
import { User } from '@pixacare/domain';
import { IsMobileService } from '@services/is-mobile.service';
import { UserNamePipe } from '@shared/pipes/user-name.pipe';
import { TuiCell, TuiDropdown, TuiHint, TuiIcon, TuiTitle } from '@taiga-ui/core';
import { TuiFade } from '@taiga-ui/kit';
import { AvatarComponent } from 'src/app/shared/components/avatar/avatar.component';
import { Size } from 'src/app/shared/models/enums/size.enum';
import { MenuAction } from 'src/app/shared/models/menu-actions/menu-action';
import { AnimateFadeDirective } from '../../shared/directives/animate-fade.directive';
import { UserActionsService } from '../user-actions.service';

@Component({
  selector: 'pxc-user-account-card',
  templateUrl: './user-account-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [UserActionsService],
  imports: [
    NgClass,
    TuiCell,
    TuiDropdown,
    TuiFade,
    TuiIcon,
    TuiHint,
    TuiTitle,
    AnimateFadeDirective,
    AvatarComponent,
    TranslocoDirective,
    UserNamePipe,
    MenuActionsComponent,
  ],
})
export class UserAccountCardComponent {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly userActionsService = inject(UserActionsService);

  // Below `md` the sidebar is a drawer taking most of the screen: there is no room beside the card for its menu.
  protected readonly isSidebarDrawer = toSignal(inject(IsMobileService).default(), { initialValue: false });

  @Input() collapsed = false;

  user: User = this.authenticationService.user;
  actions: MenuAction<User>[] = this.userActionsService.getActions();

  Size = Size;
}
